import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Localization } from '../../common/enums/localization';

@Component({
  selector: 'app-account-already-confirmed',
  templateUrl: './account-already-confirmed.component.html',
  styleUrls: ['./account-already-confirmed.component.scss']
})
export class AccountAlreadyConfirmedComponent implements OnInit {

  public readonly Localization = Localization;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  login() {
    this.router.navigateByUrl("/login");
  }
}
